import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { of } from "rxjs"; // Para retornar uma resposta mockada
import { AssinaturaService } from "../modules/shared/services/assinatura.service";

@Injectable()
export class ApiBlockAssinaturaInterceptor implements HttpInterceptor {
  constructor(private assinaturaService: AssinaturaService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      req.url.indexOf("api.supervademecum.com.br") === -1 &&
      req.url.indexOf("localhost") === -1
    ) {
      return next.handle(req);
    }

    // Avaliado antes da lista de liberadas para que o login de outro
    // usuário descarte o plano que ficou em memória
    const bloqueado = this.assinaturaService.acessoBloqueado();

    if (this.isChamadaLiberada(req.url)) {
      return next.handle(req);
    }

    // Bloquear chamadas para a API
    if (bloqueado) {
      return of(); // Retorna um Observable vazio
    }

    // Caso contrário, deixa a requisição passar
    return next.handle(req);
  }

  // Mesmo com o acesso bloqueado, o usuário precisa conseguir entrar, sair,
  // consultar o plano e pagar: tudo de conta (auth) e de assinatura/pagamento
  // fica liberado
  private isChamadaLiberada(url: string): boolean {
    const urlMinuscula = url.toLowerCase();

    return (
      urlMinuscula.includes("/auth/") ||
      urlMinuscula.includes("/assinatura/") ||
      urlMinuscula.includes("viacep.com.br/ws") ||
      urlMinuscula.includes("assets/ui/icons")
    );
  }
}
